export default __webpack_public_path__ + "static/media/AB1_Investor_Slide.db96f232.png";